{
  "name": "@homer.core/attribution",
  "version": "1.8.0",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@homer.core/channel": "*",
    "@homer.core/page": "*",
    "@homer.core/storage.local": "*",
    "@homer.core/storage.session": "*",
    "@homer.core/user": "*",
    "@homer.utility/object.filter.undefined": "*",
    "@homer.utility/validator.isfunction": "*",
    "@homer.utility/validator.isundefined": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
